import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { GlobalCurrentUserService } from "./global-current-user.service";
import { SharedService } from './shared.service';
import { NetworkService } from 'src/app/configuration/network.service';
import { API } from 'src/app/configuration/end-points';
import { environment } from 'src/environments/environment';
import { NavigationService } from 'src/@evo/services/navigation.service';
import { setSecureItem } from './secure-storage';
import { User } from '../account/login/user.model';
import { LoginService } from '../account/services/login.service';

@Injectable({
  providedIn: "root"
})
export class UserGuardService implements CanActivate {
  currentUser: any;
  menus: any[] = [];
  grantedURL: any[] = [];
  screenArray: any[] = [];
  dashboard = "dashboards/analytics";
  confiObj: any;
  KEY_VAR: any;
  IV_VAR: any;
  staticGrantedUrl = [
    '/layout/view-user',
    '/layout/view-notification-setting',
    '/layout/edit-notification-setting',
  ];
  screenName: any;
  user: User = new User();
  href: string;
  moduleId: any = "";
  constructor(
    private router: Router,
    private globalCurrentUserService: GlobalCurrentUserService,
    private sharedService: SharedService,
    private networkService: NetworkService,
    private navigationService: NavigationService,
    private loginService: LoginService
  ) { }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //console.log('RouterStateSnapshot', state);
    //console.log('ActivatedRouteSnapshot', route);

    //first reset call to action on every page
    this.sharedService.callToActions.next(false);
    this.sharedService.getConfig().subscribe(result => {

      this.confiObj = result;
      /**
      * to set params for login api in case of redirect authtoken
    */
      this.setParams();
    });
    if (!this.confiObj) {
      await this.networkService.getDecryptedPassword(environment.KEYS_FILE_NAME, environment.CONFIG_FILE_NAME);

    } else if (!this.confiObj["username"] ||
      !this.confiObj["MODULE_ID"] ||
      !this.confiObj["RESET_PASS_CALLBACK_LINK"] ||
      !this.confiObj["basicApiHost"] ||
      !this.confiObj["apiHost"] ||
      !this.confiObj["loginUrl"] ||
      !this.confiObj["MODULE_NAME"]) {

      await this.networkService.getDecryptedPassword(environment.KEYS_FILE_NAME, environment.CONFIG_FILE_NAME);

    }

    this.sharedService.getScreenPermssionList().subscribe(result => this.menus = result);
    this.currentUser = this.globalCurrentUserService.getCurrentUser();
    this.grantedURL= [];
    if (this.currentUser != null && this.menus.length === 0) {
      //this.sharedService.getScreenPermssionList().subscribe(result=> this.menus=result);
      if (this.menus.length == 0) {
        this.menus = await this.networkService.getMenuApi({ screenList: true }, API.MENUITEMS.MENUITEM);
        this.sharedService.addScreenPermissionsList(this.menus);
      }

      this.sharedService.addMenuItems(this.menus['menu']);
      this.screenArray = this.menus["screenList"];
      this.grantedURL.push(this.dashboard);
      this.screenArray && this.screenArray.forEach(result => {
        this.grantedURL.push('/' + result["screenaddress"]);
      });
      //this.grantedURL = this.grantedURL.concat(this.staticGrantedUrl);
      this.grantedURL.push('/layout/unauthorized');
      this.grantedURL.push('/layout/dashboards/analytics');
      this.grantedURL.push('/change-password');
      this.grantedURL.push('/layout/retry-claim');
      this.grantedURL.push('/layout/supporting-documents');


      //this.grantedURL.push('/layout/add-user')
      const url = state.url.split('?');
      //this.sharedService.addCurrentRoute(url);
      if (url[0] === '/change-password') {
        this.globalCurrentUserService.checkLoggedIn.next(false);
      } else {
        this.globalCurrentUserService.checkLoggedIn.next(true);
      }
      return this.checkUser(url[0]);
    } else if (this.currentUser === null && route.queryParams.token) {
   
      const ipFyresponse = await this.loginService.getIPAddressAsync();
      this.user.ipAddress = ipFyresponse["ip"]
      this.user.token = route.queryParams.token;
      //this.login();
      //console.log("before api redirect login");
      let response: any;
      try {
        response = await this.loginService.redirectLogin(this.user);
      } catch (e) {
        this.router.navigate(["/login"]);
      }

      // console.log("after api redirect login");

      this.globalCurrentUserService.setCurrentUser(
        JSON.stringify({
          accessToken: response["accessToken"],
          refreshToken: response["refreshToken"],
          title: response["title"],
          expiresIn: response["expiresIn"],
          fullName: response["fullName"],
          terrId: response["terrId"],
          userID: response["userID"],
          entityTypeId: response["entityTypeId"],
          entityId: response["entityId"]

        }),
        this.globalCurrentUserService.rememberMe
      );
      setSecureItem('currentUserId', JSON.stringify(response["userID"]));
      setSecureItem("currentUserName", JSON.stringify(response["fullName"]));

      if (this.menus.length == 0) {
        this.menus = await this.networkService.getMenuApi({ screenList: true }, API.MENUITEMS.MENUITEM);
        this.sharedService.addScreenPermissionsList(this.menus);
      }

      this.sharedService.addMenuItems(this.menus['menu']);
      this.screenArray = this.menus["screenList"];
      this.grantedURL.push(this.dashboard);
      this.screenArray && this.screenArray.forEach(result => {
        this.grantedURL.push('/' + result["screenaddress"]);
      });
      //this.grantedURL = this.grantedURL.concat(this.staticGrantedUrl);
      this.grantedURL.push('/layout/unauthorized');
      this.grantedURL.push('/layout/dashboards/analytics');
      this.grantedURL.push('/change-password');
      this.grantedURL.push('/layout/retry-claim');
      this.grantedURL.push('/layout/supporting-documents');

      //this.grantedURL.push('/layout/add-user')
      const url = state.url.split('?');
      //this.sharedService.addCurrentRoute(url);
      if (url[0] === '/change-password') {
        this.globalCurrentUserService.checkLoggedIn.next(false);
      } else {
        this.globalCurrentUserService.checkLoggedIn.next(true);
      }
      //console.log("Call redirect auth token or direct login");
      this.currentUser = this.globalCurrentUserService.getCurrentUser();
      return this.checkUser(url[0]);


    } else {
      this.screenArray = this.menus["screenList"];
      this.grantedURL.push(this.dashboard);
      this.screenArray && this.screenArray.forEach(result => {
        this.grantedURL.push('/' + result["screenaddress"]);
      })
      //this.grantedURL = this.grantedURL.concat(this.staticGrantedUrl);
      this.grantedURL.push('/layout/unauthorized');
      this.grantedURL.push('/layout/dashboards/analytics');
      this.grantedURL.push('/change-password');
      this.grantedURL.push('/layout/retry-claim');
      this.grantedURL.push('/layout/supporting-documents');


      // this.grantedURL.push('/layout/search-provider');
      // this.grantedURL.push('/layout/providers/general-information/:userId/:facilityId');
      // this.grantedURL.push('/layout/providers/fill-in-questionnaire/:facilityId');
      // this.grantedURL.push('/layout/providers/confirm-service-pricing/:facilityId');

      //this.grantedURL.push('/layout/add-user')
      const url = state.url.split('?');
      if (url[0] === '/change-password') {
        this.globalCurrentUserService.checkLoggedIn.next(false);
      } else {
        this.globalCurrentUserService.checkLoggedIn.next(true);
      }
      this.sharedService.addCurrentRoute(url);
      return this.checkUser(url[0]);
    }
    // let status = JSON.parse(localStorage.getItem("redirectToChangePassword"));
    // if (status) {
    //   this.router.navigate(["/change-password"]);
    //   return false;
    // } else {
    //   if (!this.currentUser) {
    //     this.router.navigate(["/login"]);
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }
  }

  checkUser(state: any) {
    if (!this.currentUser) {
      this.globalCurrentUserService.checkLoggedIn.next(false);
      const redirectTo = (location.pathname+location.search).substr(1)
      this.router.navigate(["/login"], { queryParams: { redirectTo: redirectTo } });
      return false;
    } else {
      // console.log(this.grantedURL, state, "granted url")
      if (!this.checkIfURLGranted(this.grantedURL, state)) {
        //alert("403: You are not authorized to access this content");
        this.router.navigate(["/layout/unauthorized"]);
        return false;
      } else {
        const url: string = state;
        this.addCurrentScreenPermission(state);
        if (state != "/change-password" && state != '/layout/unauthorized') {
          localStorage.setItem("prev-url", url);

          //breadcrumbscode
          this.navigationService.updateCrumbsByRoute(url);
          //breadcrumbscode

        }
        return true;
      }

    }
  }
  checkIfURLGranted(arr: any, url: string) {
    // console.log(url.split("/")[3]+"", "urrl")
    // if(url+"" == "/layout/search-provider" || 
    //    url.split("/")[3]+""=="general-information" || 
    //    url.split("/")[3]+""=="fill-in-questionnaire" ||
    //    url.split("/")[3]+""=="confirm-service-pricing") {
    //   return true;
    // } else {
    const params = url.split('/');
    let tempUrl: any;
    if (params.length > 2) {
      if ((params[2] + "") == "providers") {
        tempUrl = (params[0] + "").trim() + "/" + (params[1] + "").trim() + "/" + (params[2] + "").trim() + "/" + (params[3] + "").trim()
      } else {
        const action = params[2].trim();
        const para = action.split(';');
        tempUrl = params[0].trim() + "/" + params[1].trim() + "/" + para[0].trim();
        this.screenName = tempUrl;
      }
      //url = tempUrl;
      // if(this.staticGrantedUrl.includes(tempUrl)){
      //   url = tempUrl;
      // }
    }
    return arr.indexOf(url) > -1 || arr.indexOf(tempUrl) > -1;
    // }
  }

  addCurrentScreenPermission(state) {
    //console.log("this.screenName", this.screenName);
    this.screenArray && this.screenArray.forEach(result => {
      if (this.screenName === '/' + result["screenaddress"]) {
        //alert(JSON.stringify(result["screenPermission"]));
        this.sharedService.addCallToactions(result["screenPermission"]);
      }
    })
  }

  // async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  //   this.currentUser = this.globalCurrentUserService.getCurrentUser();
  //   if(this.grantedURL.length===0){
  //     this.grantedURL = await this.evoGlobalService.getRoutes();
  //     let url = state.url.split('?');
  //     return this.checkUser(url[0]);
  //   }else{
  //     let url = state.url.split('?');
  //     return this.checkUser(url[0]); 
  //   }
  // }



  // checkUser(state:any){
  //   if (!this.currentUser) {
  //     this.router.navigate(["/login"]);
  //     return false;
  //   } else {
  //     if (!this.checkIfURLGranted(this.grantedURL, state)) {
  //       alert("403: You are not authorized to access this content");
  //       return false;
  //     }else{
  //       return true;
  //     }

  //   }
  // }




  /**
   * Setting login api params like: module id, browser and OS name
   */
  setParams() {
    this.user.moduleId = this.confiObj && this.confiObj["MODULE_ID"];
    this.user.username = "test";
    this.user.password = "test";
    let OSName = "Unknown OS";
    if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
    if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
    if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
    if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
    if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";
    this.user.os = OSName;

    this.href = window.location.href;
    //console.log(this.router);
    const url = this.href.split('?');
    url && (this.user.machineName = url[0]);

    // eslint-disable-next-line prefer-const
    let ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {

      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge?)\/(\d+)/);
      if (tem != null) {
        this.user.browser = tem
          .slice(1)
          .join(" ")
          .replace("OPR", "Opera")
          .replace("Edg ", "Edge ");
        return
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);

    //console.log( M.join(' '));
    //alert( M.join(' '));
    this.user.browser = M.join(" ");

  }

  async login() {
    const response = await this.loginService.login(this.user).toPromise();
    //subscribe(response => {
    // this.globalCurrentUserService.setCurrentUser(
    //   JSON.stringify({accessToken:response["accessToken"], 
    //   refreshToken:response["refreshToken"], 
    //   title:response["title"],
    //   expiresIn:response["expiresIn"],
    //   fullName:response["fullName"],

    // }), this.globalCurrentUserService.rememberMe);
    //let forcePasswordChange = response.forcePasswordChange;
    //let forcePasswordChange = true;
    // if (forcePasswordChange) {
    //   this.sharedService.updateForceChangePassword(true);
    //   this.sharedService.updateCheckForceChangePassword(response);
    //     const dialogRef = this.dialog.open(MessageDialogComponent, {
    //       width: "400px",
    //       data: response["message"],
    //     });

    //       dialogRef.afterClosed().subscribe((result) => { this.router.navigate(["force-change-password"]);});

    // } else {
    //   this.sharedService.updateCurrentActiveUser({accessToken:response["accessToken"], 
    //   refreshToken:response["refreshToken"], 
    //   title:response["title"],
    //   expiresIn:response["expiresIn"],
    //   fullName:response["fullName"],
    //   terrId:response["terrId"],
    //   userID:response["userID"],
    //   entityTypeId:response["entityTypeId"],
    //   entityId:response["entityId"] 
    // })
    this.globalCurrentUserService.setCurrentUser(
      JSON.stringify({
        accessToken: response["accessToken"],
        refreshToken: response["refreshToken"],
        title: response["title"],
        expiresIn: response["expiresIn"],
        fullName: response["fullName"],
        terrId: response["terrId"],
        userID: response["userID"],
        entityTypeId: response["entityTypeId"],
        entityId: response["entityId"]

      }), this.globalCurrentUserService.rememberMe
    );
    setSecureItem('currentUserId', JSON.stringify(response["userID"]));
    setSecureItem("currentUserName", JSON.stringify(response["fullName"]));

    // if(response["reminder"]!=null){
    //   const dialogRef = this.dialog.open(MessageDialogComponent, {
    //     width: "400px",
    //     data: response["reminder"],
    //   });
    //     dialogRef.afterClosed().subscribe((result) => { });

    // }

    //})
  }

}
